export const ACTION_COLORS = {
  CREATE: "success",
  UPDATE: "info",
  DELETE: "error",
  LOGIN: "default",
  LOGOUT: "default",
  PAYMENT: "warning",
  PAYMENT_RECORDED: "warning",
  CONVERTED: "info",
  LOGIN_FAILED: "error",
  INVOICE_SENT: "info",
  APPROVAL_SUBMITTED: "warning",
  APPROVAL_COMPLETED: "success",
  APPROVAL_REJECTED: "error",
  ENTITY_ARCHIVED: "warning",
  ENTITY_RESTORED: "info",
  BANK_ACCOUNT_CREATED: "success",
  BANK_ACCOUNT_UPDATED: "info",
  BANK_ACCOUNT_DELETED: "error",
  BANK_IMPORT_BATCH_CREATED: "info",
  BANK_IMPORT_COMPLETED: "success",
  BANK_IMPORT_FAILED: "error",
  BANK_IMPORT_BATCH_APPROVED: "success",
  BANK_STATEMENT_IMPORTED: "info",
  RECONCILIATION_MATCHED: "success",
  RECONCILIATION_UNMATCHED: "warning",
  RECONCILIATION_OVERRIDE: "warning",
  BANK_AUTO_MATCH_RUN: "info",
  BANK_AI_MATCH_RUN: "info",
  BANK_TRANSACTION_DELETED: "error",
};

export const ACTION_LABELS = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  LOGIN: "Login",
  LOGOUT: "Logout",
  PAYMENT: "Payment",
  PAYMENT_RECORDED: "Payment",
  CONVERTED: "Converted",
  LOGIN_FAILED: "Login Failed",
  INVOICE_SENT: "Sent",
  APPROVAL_SUBMITTED: "Submitted",
  APPROVAL_COMPLETED: "Approved",
  APPROVAL_REJECTED: "Rejected",
  ENTITY_ARCHIVED: "Archived",
  ENTITY_RESTORED: "Restored",
  BANK_ACCOUNT_CREATED: "Account Connected",
  BANK_ACCOUNT_UPDATED: "Account Updated",
  BANK_ACCOUNT_DELETED: "Account Removed",
  BANK_IMPORT_BATCH_CREATED: "Import Started",
  BANK_IMPORT_COMPLETED: "Import Completed",
  BANK_IMPORT_FAILED: "Import Failed",
  BANK_IMPORT_BATCH_APPROVED: "Import Approved",
  BANK_STATEMENT_IMPORTED: "Statement Imported",
  RECONCILIATION_MATCHED: "Reconciled",
  RECONCILIATION_UNMATCHED: "Unmatched",
  RECONCILIATION_OVERRIDE: "Expense from Transaction",
  BANK_AUTO_MATCH_RUN: "Auto-Match",
  BANK_AI_MATCH_RUN: "AI Match",
  BANK_TRANSACTION_DELETED: "Transaction Removed",
};

export const CATEGORY_OPTIONS = [
  { value: "", label: "All Categories" },
  { value: "financial", label: "Financial" },
  { value: "security", label: "Security" },
  { value: "settings", label: "Settings" },
  { value: "banking", label: "Banking" },
  { value: "system", label: "System" },
];

export const RISK_OPTIONS = [
  { value: "", label: "All Risk Levels" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const ENTITY_TYPE_OPTIONS = [
  { value: "", label: "All Modules" },
  { value: "invoice", label: "Invoice" },
  { value: "quote", label: "Quote" },
  { value: "bill", label: "Bill" },
  { value: "expense", label: "Expense" },
  { value: "purchase_order", label: "Purchase Order" },
  { value: "sales_order", label: "Sales Order" },
  { value: "customer", label: "Customer" },
  { value: "vendor", label: "Vendor" },
  { value: "product", label: "Product" },
  { value: "payment", label: "Payment" },
  { value: "tax_rate", label: "Tax Rate" },
  { value: "organization_profile", label: "Organization" },
  { value: "invoice_preferences", label: "Invoice Preferences" },
  { value: "user", label: "User" },
  { value: "auth", label: "Auth" },
  { value: "bank_account", label: "Bank Account" },
  { value: "bank_import_batch", label: "Bank Import" },
  { value: "bank_transaction", label: "Bank Transaction" },
];

export const ACTION_OPTIONS = [
  { value: "", label: "All Actions" },
  { value: "CREATE", label: "Created" },
  { value: "UPDATE", label: "Updated" },
  { value: "DELETE", label: "Deleted" },
  { value: "CONVERTED", label: "Converted" },
  { value: "PAYMENT_RECORDED", label: "Payment" },
  { value: "LOGIN", label: "Login" },
  { value: "LOGOUT", label: "Logout" },
  { value: "LOGIN_FAILED", label: "Login Failed" },
];

export const RISK_COLORS = {
  low: "success",
  medium: "warning",
  high: "error",
};
